import type { ImportSummary } from '#shared/types';
import { Card } from '#client/components/ui/Card';
import { formatCount, formatMoney } from '#client/lib/format';

/** The counts a check produced: what the import will create, update and skip. */
export function CheckSummaryCard({ summary }: { summary: ImportSummary }) {
  return (
    <Card title="What this will do">
      <dl className="c-summary">
        <div className="c-summary__row">
          <dt>New rows</dt>
          <dd>{formatCount(summary.creates)}</dd>
        </div>
        <div className="c-summary__row">
          <dt>Updates</dt>
          <dd>{formatCount(summary.updates)}</dd>
        </div>
        <div className="c-summary__row">
          <dt>Skipped</dt>
          <dd>{formatCount(summary.skips)}</dd>
        </div>
        {summary.errors > 0 && (
          <div className="c-summary__row">
            <dt>Needing attention</dt>
            <dd className="c-import-failed">{formatCount(summary.errors)}</dd>
          </div>
        )}
        {summary.price_changes !== null && summary.price_changes > 0 && (
          <div className="c-summary__row c-summary__row--total">
            <dt>Price changes</dt>
            <dd>
              {summary.price_changes} tests, net {(summary.price_delta ?? 0) >= 0 ? '+' : '−'}
              {formatMoney(Math.abs(summary.price_delta ?? 0))}
            </dd>
          </div>
        )}
      </dl>
    </Card>
  );
}
